import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ShippingOrder } from 'src/app/admin-api';
import { StorageService } from 'src/app/services/auth/storage.service';
import { environment } from 'src/environments/environment';

/**
 * Resumo de um reenvio de uma mesma edição de assinante. Espelha o DTO
 * `EditionResendSummary` do admin-api. Mantido como serviço próprio (fora da
 * pasta gerada `admin-api/`) porque consome endpoints ainda não presentes no
 * client OpenAPI gerado.
 */
export interface EditionResendSummary {
  shippingOrderRequestId?: number;
  subscriberEditionId?: number;
  shippingOrderIdResend?: number;
  shippingOrderIdOriginal?: number;
  requestStatus?: number;
  requestStatusName?: string;
  shippingOrderStatus?: number;
  shippingOrderStatusName?: string;
  dateCreated?: string;
  dateSyncERP?: string;
  ticketId?: number;
  ticketOrigin?: string;
  ticketSubject?: string;
  current?: boolean;
}

interface ResponseB4A<T> {
  result: T;
}

@Injectable({ providedIn: 'root' })
export class ResendDuplicityService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/shipping-order`;

  private authHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${StorageService.token}`
    });
  }

  /** Lista os reenvios existentes para uma edição (para detectar duplicidade). */
  getEditionResends(
    subscriberEditionId: number
  ): Observable<EditionResendSummary[]> {
    return this.http
      .get<ResponseB4A<EditionResendSummary[]>>(
        `${this.baseUrl}/edition-resends/${subscriberEditionId}`,
        { headers: this.authHeaders() }
      )
      .pipe(map((data) => data.result ?? []));
  }

  /**
   * Aprova reenvios. Quando a edição já possui outros reenvios não cancelados,
   * o backend exige `confirmDuplicates = true` (aprovação humana consciente).
   */
  approveResends(
    shippingOrderRequestIds: number[],
    confirmDuplicates = false
  ): Observable<ShippingOrder[]> {
    return this.http
      .post<ResponseB4A<ShippingOrder[]>>(
        `${this.baseUrl}/request/approve`,
        shippingOrderRequestIds,
        {
          headers: this.authHeaders(),
          params: new HttpParams().set(
            'confirmDuplicates',
            confirmDuplicates ? 'true' : 'false'
          )
        }
      )
      .pipe(map((data) => data.result));
  }
}
